import resolveConfig from 'tailwindcss/resolveConfig'
import * as tailwindConfig from '../../tailwind.config.mjs'

const config = resolveConfig(tailwindConfig)
const {
  theme: { colors },
} = config

export default colors
